import React, { FC } from 'react';

const OWTag: FC<any> = ({ negativeMargin = false, children }): React.ReactElement => {
	return (
		<div
			className={`inline-block whitespace-nowrap rounded-md border border-gray-300 bg-gray-100 px-3 py-1 text-sm text-gray-700 ${
				negativeMargin ? '-mx-[1px] -my-[3px] ' : ''
			}`}
		>
			{children}
		</div>
	);
};

export default OWTag;
